module.exports = {
      id: "home-banner-adguards-usage",
      viewBox: "0 0 500 250",
      url: __webpack_public_path__ + "images/js_src_vue/page_adguard_landing/sprite.dab809d9.svg#home-banner-adguards-usage",
      toString: function () {
        return this.url;
      }
    }